module.exports = __webpack_public_path__ + "img/trial3-4.57684450.png";